import React from "react";
import { useActiveCartItem } from "../CartItemModalRootScreen/hooks";
import { useHasTransitionEnded } from "../../../../utilities/use-after-interactions";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { ActionsRootParamList, CartItemRootParmList } from "../../../../types";
import { View } from "react-native-ui-lib";
import {
  Button,
  Page,
  TextButton,
  TextField,
} from "@towersystems/roam-common-native";
import { useSaleControllerProvider } from "../../utils/sale-controller";

interface EditPurchaseOrderNumberScreenProps
  extends NativeStackScreenProps<
    ActionsRootParamList,
    "EditPurchaseOrderNumberScreen"
  > {}

export const EditPurchaseOrderNumberScreen = ({
  navigation,
}: EditPurchaseOrderNumberScreenProps) => {
  const { sale } = useSaleControllerProvider();

  const [value, setValue] = React.useState(sale?.purchaseOrderNumber || "");
  const [initialValue, setInitialValue] = React.useState(
    sale?.purchaseOrderNumber || ""
  );

  const shouldFocus = useHasTransitionEnded(navigation);
  const title = sale?.purchaseOrderNumber
    ? "Edit Order Purchase Number"
    : "Add Order Purchase Number";

  const handleOnSave = React.useCallback(async () => {
    return sale
      ?.setPurchaseOrderNumber(value)
      .then(() => navigation.goBack())
      .catch((err) => console.log(err));
  }, [sale, value]);

  const handleOnRemove = React.useCallback(async () => {
    return sale
      ?.setPurchaseOrderNumber(undefined)
      .then(() => navigation.goBack())
      .catch((err) => console.log(err));
  }, [sale]);

  React.useEffect(() => {
    navigation.setOptions({
      headerTitle: title,
      headerRight: () => (
        <Button
          label="Generate Number"
          isAction
          size="compact"
          onPress={() => {
            const v = sale?.generatePurchaseOrderNumber();
            setValue(v ?? "");
          }}
        ></Button>
      ),
    });
  }, [title, handleOnSave]);

  const footer =
    initialValue === value && value !== "" ? (
      <View>
        <Button
          onPress={handleOnRemove}
          label="Remove purchase order number"
          isDestructive
        ></Button>
      </View>
    ) : (
      <View>
        <Button
          onPress={handleOnSave}
          label="Update purchase order number"
          disabled={value == initialValue}
          isAction
        ></Button>
      </View>
    );

  return (
    <Page footer={footer}>
      <View style={{ height: "100%" }} flex>
        <TextField
          textarea
          placeholder="Enter purchase order number..."
          value={value}
          onChangeText={(v) => setValue(v)}
          autoFocus={shouldFocus}
        />
      </View>
    </Page>
  );
};
